import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HomePage from './HomePage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ClientLanding = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      const sessionToken = localStorage.getItem('session_token');
      if (sessionToken) {
        try {
          const response = await fetch(`${BACKEND_URL}/api/auth/me`, {
            headers: {
              Authorization: `Bearer ${sessionToken}`,
            },
          });
          if (response.ok) {
            navigate('/dashboard');
            return;
          }
        } catch (err) {
          console.error('Session check failed:', err);
        }
      }
      setLoading(false);
    };
    checkSession();
  }, [navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="loading-spinner" />
      </div>
    );
  }

  return <HomePage />;
};

export default ClientLanding;
